var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"legal-page"},[_c('HeadNav',{attrs:{"selectedLanguage":"en","page":_vm.page,"gotodownload":_vm.gotodownload,"apk":_vm.apk}}),_vm._v(" "),_c('main',{staticClass:"legal-content"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }